<template>
  <div id="app">
    <div class="app__layout">
      <Sidebar class="app__layout__sidebar" />
      <div class="app__layout__wrapper relative">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar";

export default {
  name: "app",
  components: { Sidebar },
  created() {
    this.$store.dispatch("AUTHENTICATE");
    this.$store.dispatch("GET_CURRENT_USER");
  },
  data() {
    return {
      collapsed: false,
    };
  },
  methods: {
    signOut() {
      this.$store.dispatch("SIGN_OUT");
    },
  },
};
</script>

<style>
* {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.app__layout {
  position: relative;
  width: 100%;
  display: flex;
}
.app__layout__sidebar {
  width: 200px;
  position: sticky;
  top: 0;
}
.app__layout__wrapper {
  min-height: 100vh;
  flex: 1;
  background-color: #fff;
  overflow: hidden;
}
</style>
